import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 5px;
`;

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > ${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;

		&:first-child {
			opacity: 0.25;
		}
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

export { StyledButtonContent, StyledContainer, StyledInfoContainer, StyledRow };
